$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_promo_code_product' && a === 'list') {
    let promo_code_product_delete_ajax_lock = false;

    $(document).on('click', '.promo-code-product-delete-button', function () {
      let productId = $(this).attr('data-product-id');
      let promoCodeId = $(this).attr('data-promo-code-id');
      let locationId = $('body').attr('event_id');

      if (!promo_code_product_delete_ajax_lock) {
        promo_code_product_delete_ajax_lock = true;

        $.ajax({
          type: 'POST',
          url: '/ajax/organizer_promo_code_product/delete',
          data: {
            promo_code_id: promoCodeId,
            product_id: productId,
            location_id: locationId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $('#promo-code-product-list-sortable').empty();
              $('#promo-code-product-list-sortable').append(data.html);
              popupAlert();
            }

            if (data.product !== undefined && data.product !== null) {
              $("select[name='product_id']").prepend(
                $('<option>', {
                  value: productId,
                  text: data.product,
                })
              );
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            promo_code_product_delete_ajax_lock = false;
          })
          .always(function () {
            promo_code_product_delete_ajax_lock = false;
          });
      }
    });
  }
});
